var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-spacer'),_c('v-img',{attrs:{"src":"https://tenor.com/view/ok-sorry-homer-simpsons-gif-9894844.gif"}}),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }